import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';
import Home from './Home';
import styles from './styles';

function mapStateToProps(state) {
  const {
    isLoading, requests, error, message, ongoing, done, data, currentPage, totalPage, totalData,
  } = state.request;
  return {
    isLoading,
    requests,
    error,
    message,
    ongoing,
    done,
    data,
    currentPage,
    totalPage,
    totalData,
  };
}

const Styled = withStyles(styles)(Home);

export default connect(
  mapStateToProps,
)(Styled);
